import { Controller, FieldValues } from 'react-hook-form';
import DateRangePickerWithTextField from '../DateRangePickerWithTextField';
import { IReactHookFormDateRangePickerWithTextFieldProps } from '../../index';

const ReactHookFormDateRangePickerWithTextField = <
  TFieldValues extends FieldValues
  >(props: IReactHookFormDateRangePickerWithTextFieldProps<TFieldValues>) => {
  const {
    name,
    control,
    defaultValue,
    rules,
    shouldUnregister,
    ...dateRangePickerProps
  } = props;

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={rules}
      shouldUnregister={shouldUnregister}
      render={({
        field: { value, onChange },
      }) => {
        const {
          onSubmit,
          onClear,
          ...restDateRangePickerProps
        } = dateRangePickerProps;
        return (
          <DateRangePickerWithTextField
            {...restDateRangePickerProps}
            from={value.from}
            to={value.to}
            onSubmit={(newValue) => {
              onChange(newValue);
              if (onSubmit) {
                onSubmit(newValue);
              }
            }}
            onClear={(newValue) => {
              onChange(newValue);
              if (onClear) {
                onClear(newValue);
              }
            }}
          />
        );
      }}
    />
  );
};

export default ReactHookFormDateRangePickerWithTextField;
